import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createPurpose,
  deletePurpose,
  getPurpose,
  getPurposes,
  getPurposesMasterData,
  updatePurpose
} from '../../../api/purposes';
import { Revision } from '../Revision/revisionSlice';

export const getPurposesAsync = createAsyncThunk(
  'purposes/getPurposes',
  getPurposes
);

export const getPurposesMasterDataAsync = createAsyncThunk(
  'purposes/getPurposesMasterData',
  getPurposesMasterData
);

export const getPurposeAsync = createAsyncThunk(
  'purposes/getPurpose',
  getPurpose
);

export const createPurposeAsync = createAsyncThunk(
  'purposes/createPurpose',
  createPurpose
);

export const updatePurposeAsync = createAsyncThunk(
  'purposes/updatePurpose',
  updatePurpose
);

export const deletePurposeAsync = createAsyncThunk(
  'purposes/deletePurpose',
  deletePurpose
);

export interface Purpose {
  id: number;
  abbreviation: string;
  fullName: string;
  phase: string;
  revisions: Revision[];
}

interface PurposeState {
  data: Purpose[];
  masterData: Purpose[];
  count: number;
  selectedPurpose: Purpose | null;
}

const initialState: PurposeState = {
  data: [],
  masterData: [],
  count: 0,
  selectedPurpose: null
};

export default createSlice({
  name: 'purposes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPurposesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(getPurposesMasterDataAsync.fulfilled, (state, action) => {
      state.masterData = action.payload.data;
      state.count = action.payload.count;
    });
    builder.addCase(getPurposeAsync.fulfilled, (state, action) => {
      state.selectedPurpose = action.payload;
    });
  }
});
